export const activeQuestions = [1, 3, 4, 5, 7, 16, 23, 24];
